module.exports = __webpack_public_path__ + "static/media/oberflex-acajout19-1200x2490.06abd7ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-acajout19-1200x2490.jpg
// module id = 968
// module chunks = 37